<template>
  <section class="py-5 boost" id="topup">
    <div class="container" data-aos="fade-up" data-aos-duration="2000">
      <div
        class="row mx-0 justify-content-center align-items-center text-center"
      >
        <div class="col-lg-12 text-white text-break">
          <!-- <img
            src="../../assets/images/new_design_v6/ExtraBoost.png"
            class="boost-main-img"
          /> -->
          <picture>
            <source
              media="(max-width: 1480px)"
              srcset="../../assets/images/new_design_v6/ExtraBoost2.png"
            />
            <img
              src="../../assets/images/new_design_v6/ExtraBoost.png"
              class="boost-main-img"
            />
          </picture>
          <div class="boost-text-container">
            <p class="boost-text-sub-header fw-bold text-uppercase mb-0">
              Up to 100mbps
            </p>
            <p class="boost-text-info fw-medium mt-2">
              <span class="fw-bold"
                >P1,699 lang, konektado ka na - may 30 days load na up to 100
                Mbps!</span
              >
              <br class="d-none d-lg-block" />
              Ang saya, <span class="fst-italic">'</span>di ba? Surf na,
              Fiberkads!
            </p>
          </div>
          <div
            class="boost-extra-container d-flex pt-3 flex-lg-row flex-column flex-wrap flex-lg-nowrap justify-content-center align-items-center"
          >
            <img
              src="../../assets/images/new_design_v4/Extra180.png"
              class="boost-extra-img shadow-lg"
            />
            <img
              src="../../assets/images/new_design_v4/Extra380.png"
              class="boost-extra-img shadow-lg"
            />
            <img
              src="../../assets/images/new_design_v4/Extra550.png"
              class="boost-extra-img shadow-lg"
            />
            <img
              src="../../assets/images/new_design_v4/Extra999.png"
              class="boost-extra-img shadow-lg"
            />
          </div>
          <div class="pt-5">
            <!-- <p class="boost-text-info fst-italic fw-medium">
              SkyTV is offered in partnership with Reliance Broadcasting
              Unlimited, Inc.
            </p> -->
            <!-- <p class="boost-terms fw-medium">
              Terms and Conditions apply. Promo Period:
              <span class="fw-semibold"
                >October 20, 2025 to December 31, 2025,</span
              ><br />
              Per DTI Fair Trade Permit No. FTEB-240511 Series of 2025
            </p> -->
            <!-- <div>
              <a
                href="#"
                @click.prevent="showSkyTvModal"
                class="boost-link fw-semibold text-decoration-none text-white mt-2"
              >
                See SkyTV Channels
              </a>
            </div> -->
            <button
              type="button"
              class="boost-btn text-white fw-normal mt-4"
              @click="redirectTopUp"
            >
              Buy S2S Load
            </button>
          </div>
        </div>
      </div>
    </div>
    <SkyTvChannels />
  </section>
</template>

<script>
import { Modal } from "bootstrap";
import SkyTvChannels from "../../components/SkyTvChannels.vue";
export default {
  name: "TopupSection",
  components: {
    SkyTvChannels,
  },
  methods: {
    showSkyTvModal() {
      const modalElement = document.getElementById("skyTvModal");
      if (modalElement) {
        const modal = new Modal(modalElement);
        modal.show();
      }
    },
    redirectTopUp() {
      window.open("https://buyload.surf2sawa.com/topup", "_self");
      // this.$router.push({ path: "/topup" });
    },
  },
};
</script>
